export default __webpack_public_path__ + "static/media/cfirst-logo-4mar26.45c721bb.png";